export default __webpack_public_path__ + "static/media/salento.0b32916d.jpeg";